export default __webpack_public_path__ + "static/media/FinkTrussImg.4fac2650.png";